export const getSurveyForms = (state) => state.survey.forms;
export const getSingleSurveyForm = (state) => state.survey.singleForm;
